
const state = {
  id: null,
  service_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'service_id' },
  { key: 'title' },
]

export default state
